// ------------------------------------
// Constants
// ------------------------------------
export const NETWORK_INSTANCE_CHANGE_STATE_REQUEST =
  "NETWORK_INSTANCE_CHANGE_STATE_REQUEST";
export const NETWORK_INSTANCE_CHANGE_STATE_REQUEST_SUCCESS =
  "NETWORK_INSTANCE_CHANGE_STATE_REQUEST_SUCCESS";
export const NETWORK_INSTANCE_CHANGE_STATE_REQUEST_FAILURE =
  "NETWORK_INSTANCE_CHANGE_STATE_REQUEST_FAILURE";

// ------------------------------------
// Actions
// ------------------------------------
export function request(payload, resolve, reject) {
  return {
    type: NETWORK_INSTANCE_CHANGE_STATE_REQUEST,
    payload,
    resolve,
    reject,
  };
}

export function requestSuccess(res, payload) {
  return {
    type: NETWORK_INSTANCE_CHANGE_STATE_REQUEST_SUCCESS,
    data: res,
    payload,
  };
}

export function requestFailure(error, payload) {
  return {
    type: NETWORK_INSTANCE_CHANGE_STATE_REQUEST_FAILURE,
    error,
    payload,
  };
}
